import {
  api_increment_user_onboarding_attempt_path,
  api_update_user_onboarding_path,
  api_user_onboarding_path,
} from '@routes';

import request from './request';

export const USER_ONBOARDING_KEY = 'USER_ONBOARDING_KEY';
export const ONBOARDING_SESSION_KEY = 'ti_onboarding_shown_this_session';

export enum SubscribeSource {
  PAYWALL = 'paywall',
  PROMO = 'promo',
}

export interface UserOnboarding {
  lastStepCompleted: number | null;
  status?: string;
  attemptCount?: number;
  completedAt?: string;
  lastAttemptAt?: string;
  nextAttemptAt?: string;
  shouldShowImmediately?: boolean;
  subscribeSource?: SubscribeSource;
}

export interface UpdateUserOnboardingParams {
  lastStepCompleted?: number;
}

export async function getUserOnboarding(): Promise<UserOnboarding> {
  const resp = await request('get', api_user_onboarding_path());
  return resp;
}

export async function updateUserOnboarding(
  params: UpdateUserOnboardingParams
): Promise<UserOnboarding> {
  const resp = await request('patch', api_update_user_onboarding_path(), {
    last_step_completed: params.lastStepCompleted,
  });
  return resp;
}

export async function incrementOnboardingAttempt(): Promise<UserOnboarding> {
  const resp = await request('post', api_increment_user_onboarding_attempt_path());
  return resp;
}

/**
 * Check if the onboarding modal has been shown in the current session
 */
export function hasShownOnboardingThisSession(): boolean {
  try {
    return sessionStorage.getItem(ONBOARDING_SESSION_KEY) === 'true';
  } catch {
    return false;
  }
}

/**
 * Mark the onboarding modal as shown for the current session
 */
export function markOnboardingShownThisSession(): void {
  try {
    sessionStorage.setItem(ONBOARDING_SESSION_KEY, 'true');
  } catch {
    // Ignore errors (e.g., private browsing mode)
  }
}
